import React from 'react'
import LandingHeader from './LandingHeader'
import FooterOther from './FooterOther'

const KnowTheProcess = () => {
    return (
        <div>
            <LandingHeader />

            <div className='max-w-[1300px] flex justify-center m-auto px-[10px]'>

                <div className='FJCIC mt-[40px]'>
                    <h2 className=' text-center text-main_color font-normal leading-8 text-[25px]  lg:text-[30px] xl:text-[44px] font-sans'>
                        The Process of Integrating LexiLearn
                        in Your School/College</h2>
                </div>
                {/* <div className='w-full h-[35vh] lg:h-[80vh] bg-main_color px-[40px] py-[40px]'> */}



                {/* </div> */}


            </div>
            <div className='w-full h-[100vh] mt-[60px]'>

            <div className='know_the_process'>

            </div>
            </div>


            {/* enquiry section start  */}
            <div className=''>
                <div className='FJCIC'>
                    <h2 className=' text-main_color font-[400] text-[30px] lg:text-[44px] from-neutral-50 mt-[20px]'>For More Enquiry</h2>
                </div>

                <div className='flex justify-center text-main_color font-normal text-[14px] w-full '>
                    <div className='w-[90%] lg:w-[50%] text-center'>
                        <p className='w-full '>
                            Have questions or need more information? We’re here to help! Reach out to us for any enquiry, feedback, or support. Our team will get back to you promptly. Contact us directly—we’d love to hear from you!
                        </p>
                    </div>

                </div>
                <div className='flex justify-center my-[20px]'>
                    <a href="/contact-us"><button className='button_red'>Contact Us</button></a>
                </div>
            </div>
            {/* enquiry section end */}
            <FooterOther />
        </div>
    )
}

export default KnowTheProcess